import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IComponentProps } from './index';

export const generate = (
  props?: Partial<IComponentSchema<IComponentProps>>
): IComponentSchema<IComponentProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Folder Preview',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.FolderPreview,
    'x-component-props': {
      height: 800,
      emptyStateText: 'Select a file to preview',
      downloadButtonText: 'Download',
      previewButtonNotAvailableText: 'Preview not available for this file type',
      visible: true,
    },
    'x-component-props-config': {},
  };
};
